export default "assets/images/validate-4f8a36e9.svg";